module.exports = __webpack_public_path__ + "img/vien-uong-hapanix-2.9fea37c7.jpg";